import { Box, TextField } from '@mui/material';
import OAuthCredentialScopes from './OAuthCredentialScopes';

const GRID_SX = {
  display: 'grid',
  gap: 2,
  gridTemplateColumns: { xs: '1fr', md: '1fr 1fr' },
};

const FIRST_COLUMN = { gridColumn: { md: 1 } };

const NEXT_COLUMN = {};

const STORED_SECRET_HINT = 'Leave blank to keep the stored secret';

const CredentialTextField = ({
  name,
  label,
  value,
  error,
  disabled,
  onChange,
  sx = FIRST_COLUMN,
  type = 'text',
  helperText = error,
  autoComplete = 'off',
}) => (
  <TextField
    label={label}
    id={`oauth_credential_${name}`}
    name={name}
    type={type}
    value={value}
    onChange={(e) => onChange(name, e.target.value)}
    disabled={disabled}
    size='small'
    fullWidth
    error={!!error}
    helperText={helperText}
    autoComplete={autoComplete}
    sx={sx}
  />
);

const toSecretHelperText = (error, hasClientSecret) => {
  if (error || !hasClientSecret) {
    return error;
  }
  return STORED_SECRET_HINT;
};

const OAuthCredentialFields = ({
  form,
  fieldErrors,
  disabled,
  hasClientSecret,
  settingsFields,
  showTokenUrl,
  scopeOptions,
  availableScopes,
  onFieldChange,
  onSettingChange,
}) => (
  <Box sx={GRID_SX}>
    {settingsFields.map((field) => (
      <CredentialTextField
        key={field.name}
        name={field.name}
        label={field.label}
        value={form.settings[field.name]}
        error={fieldErrors[field.name]}
        disabled={disabled}
        onChange={onSettingChange}
      />
    ))}

    {showTokenUrl && (
      <CredentialTextField
        name='token_url'
        label='Token URL'
        value={form.token_url}
        error={fieldErrors.token_url}
        disabled={disabled}
        onChange={onFieldChange}
      />
    )}

    <CredentialTextField
      name='client_id'
      label='Client ID'
      value={form.client_id}
      error={fieldErrors.client_id}
      disabled={disabled}
      onChange={onFieldChange}
    />

    <CredentialTextField
      name='client_secret'
      label='Client Secret'
      type='password'
      value={form.client_secret}
      error={fieldErrors.client_secret}
      helperText={toSecretHelperText(
        fieldErrors.client_secret,
        hasClientSecret,
      )}
      disabled={disabled}
      onChange={onFieldChange}
      sx={NEXT_COLUMN}
      autoComplete='new-password'
    />

    <OAuthCredentialScopes
      availableScopes={availableScopes}
      scopes={form.scopes}
      error={fieldErrors.scopes}
      disabled={disabled}
      freeText={!scopeOptions}
      sx={FIRST_COLUMN}
      onChange={(scopes) => onFieldChange('scopes', scopes)}
    />
  </Box>
);

export default OAuthCredentialFields;
